module.exports = __webpack_public_path__ + "static/1-be7a89345fd8f0ff8af9d231fc2e4b6e.png";